import React from 'react';
import propTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';
import { Camera } from '../../../../../../editJournal/toolset/assets/icons';
import EditImage from '../../PersonalInfo/editImage';
import generateObjectURL from '../../../../../../../../../utility/action-images/getBlob/generateObjectURL';
import Actions from '../../../../../../../../../store/actions';
import getToken from '../../../../../../../../../utility/getToken';
import GetPresignURL from '../../../../../../../../../utility/getPresignURLController';
import getFileKey from '../../../../../../../../../utility/getFileKey';
import ImageUploadStatus from '../../PersonalInfo/imageUploadStatus';
import RenderImage from '../../PersonalInfo/renderImage';
import {
  getBlobData,
  getData,
} from '../../../../../../Export/Resume/resume/shared/blobUrlhelpers';

const Wrapper = styled.div`
  user-select: none;
  -webkit-user-select: none;
  ${({ showImage }) => {
    if (!showImage) {
      return css`
        display: none;
      `;
    }
    return css``;
  }}
`;

class Image extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      blobURL: null,
      blobPresent: false,
      isUploading: false,
      imageUploadFailed: false,
      snackBarMessage: null,
      nodeKey: null,
    };
  }

  iconSelector = React.createRef();

  componentWillUnmount() {
    const {
      nodeProps: {
        node: { data },
      },
      updateUnusedUrls,
      editor,
    } = this.props;
    const {
      props: { saveDocument, setSaveToggler, parentRef },
    } = editor;
    const { blobURL } = this.state;

    const parsedNodeData = getData(data.get('src'));
    if (blobURL && parsedNodeData && parentRef.current) {
      updateUnusedUrls({
        unUsedUrl: parsedNodeData.path,
      });
      setSaveToggler(false);
      setTimeout(() => saveDocument(true), 0);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      nodeProps: {
        node: { data: prevData },
      },
    } = prevProps;
    const {
      nodeProps: {
        node: { data },
      },
      updateUnusedUrls,
      blobURLs,
    } = this.props;
    const { blobURL, isUploading } = this.state;

    const parsedNodeData = getData(data.get('src'));

    const prevParsedNodeData = getData(prevData.get('src'));

    if (
      parsedNodeData &&
      blobURLs &&
      blobURLs[parsedNodeData.path] &&
      blobURL !== blobURLs[parsedNodeData.path] &&
      !isUploading
    ) {
      this.setState({
        blobURL: blobURLs[parsedNodeData.path],
        blobPresent: true,
      });
      updateUnusedUrls({
        unUsedUrl: prevParsedNodeData && prevParsedNodeData.path,
        currentUrl: parsedNodeData.path,
      });
    } else if (!parsedNodeData && blobURL && !isUploading) {
      this.setState({
        show: false,
        blobURL: null,
        blobPresent: 'empty',
        isUploading: false,
        imageUploadFailed: false,
        snackBarMessage: null,
      });
      updateUnusedUrls({
        unUsedUrl: prevParsedNodeData && prevParsedNodeData.path,
      });
    }
  }

  componentDidMount = async () => {
    const { blobURLs, updateBlobURL, unUsedUrls, editor, updateUnusedUrls } =
      this.props;
    const {
      nodeProps: {
        key,
        node: { data: nodeData },
      },
    } = this.props;
    const {
      props: { saveDocument, setSaveToggler },
    } = editor;
    const parsedNodeData = getData(nodeData.get('src'));
    if (parsedNodeData) {
      const { path } = parsedNodeData;
      const response = await getBlobData(parsedNodeData, blobURLs);
      const { blobURL, isPresent } = response;
      if (isPresent) {
        this.setState({
          blobURL,
          blobPresent: true,
          nodeKey: key,
        });
      } else {
        this.setState({ blobURL, blobPresent: true, nodeKey: key });

        /**
         * Update blob url in redux for first blob
         */
        updateBlobURL({
          documentPicture: {
            path,
            blobURL,
          },
          document: true,
        });
      }

      if (unUsedUrls && unUsedUrls[path]) {
        updateUnusedUrls({ unUsedUrl: null, currentUrl: path });
        setSaveToggler(false);
        setTimeout(saveDocument, 0);
      }
    } else {
      this.setState({ nodeKey: key });
    }
  };

  setDefaultPicture = () => {
    this.setState({
      blobPresent: 'defaultPicture',
    });
  };

  handleOpenDropdown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState((state) => ({
      show: !state.show,
    }));
  };

  closeDropDown = () => this.setState({ show: false });

  handleClickOutside = (e) => {
    if (
      this.iconSelector.current &&
      !this.iconSelector.current.contains(e.target)
    ) {
      this.setState({ show: false });
    }
  };

  handleCloseDropdown = (e) => {
    // e.preventDefault();
    e.stopPropagation();
    const {
      target: { classList, parentElement },
    } = e;

    const { nodeKey } = this.state;
    let parentClassList = '';

    if (parentElement) {
      parentClassList = parentElement.classList;
    }
    /**
     * This is to stop the close drop down,
     * to complete the event triggered for file upload
     *
     * When the user clicks on the text - we need to check parent's(label) classList
     * When the user clicks on the label itself on either side of text - we need to check the element's classList
     */
    if (
      classList.contains(`fileUpload_${nodeKey}`) ||
      (parentClassList && parentClassList.contains(`fileUpload_${nodeKey}`))
    )
      return;

    this.closeDropDown();
  };

  handleRemoveDocumentPicture = async () => {
    const { nodeKey } = this.state;
    const {
      editor,
      nodeProps: {
        node: { data },
      },
    } = this.props;
    const {
      props: { saveDocument, setSaveToggler },
    } = editor;
    if (data.get('src')) {
      this.setState({
        blobPresent: 'empty',
        blobURL: null,
        isUploading: false,
      });
      editor.setNodeByKey(nodeKey, {
        data: {
          src: null,
        },
      });
      setSaveToggler(false);
      setTimeout(saveDocument, 0);
    }
  };

  onChange = async (e) => {
    e.preventDefault();
    const { blobURL: prevBlobURL, nodeKey } = this.state;
    const {
      editor,
      nodeProps: { key },
      updateBlobURL,
    } = this.props;
    const documentId = key;
    const {
      props: { saveDocument, setSaveToggler },
    } = editor;
    const {
      target: { files },
    } = e;
    const file = files[0];
    const isValidFile = ['image/png', 'image/jpeg'].includes(file.type);

    if (isValidFile) {
      /**
       * When there is no internet connect
       */
      if (!navigator.onLine) {
        this.setState({
          // imageUploadFailed: true,
          snackBarMessage: 'Failed to upload. Please check connection',
        });
        return;
      }

      try {
        /**
         * Generate a blob
         */
        const blobURL = generateObjectURL(file);
        this.setState({ blobURL, isUploading: true, blobPresent: true });

        /**
         * Generate a key
         */
        const ext = file.type.split('/')[1];
        const path = `${`resume/${documentId}/${uuidv4()}.${ext}`}`;

        /**
         * Upload to s3
         */
        const token = await getToken();

        // Getting file path for uploading the image
        const filePath = `${`${await getFileKey('private')}/${path}`}`;

        const data = {
          name: filePath,
          contentType: file.type,
          methodType: 'putObject',
        };
        const preSignedURL = await GetPresignURL.getPresignedURL(data, token);
        const isUploaded = await GetPresignURL.uploadDataToS3(
          preSignedURL,
          file,
        );

        if (isUploaded) {
          this.setState({
            isUploading: false,
            blobPresent: true,
          });

          /**
           * Update the redux with the key
           */
          editor.setNodeByKey(nodeKey, {
            data: {
              src: { path: filePath, type: file.type },
            },
          });
          updateBlobURL({
            documentPicture: {
              path: filePath,
              blobURL,
            },
            document: true,
          });
          setSaveToggler(false);
          setTimeout(saveDocument, 0);
        }
      } catch (err) {
        this.setState({
          blobURL: prevBlobURL,
          isUploading: false,
          imageUploadFailed: true,
          snackBarMessage: 'Failed to upload. Please try again later!',
        });
      }
    } else {
      this.setState({
        imageUploadFailed: true,
        snackBarMessage:
          'Apologies, but we can only accept jpg, jpeg, png, and gif files. Please try again',
      });
    }
  };

  /**
   * Allows to upload same image multiple times
   * useful when user uses his local software to modify the image and uploads to wisedoc
   */
  clearEventValue = (e) => {
    e.target.value = '';
    this.closeDropDown();
  };

  handleCloseSnackBar = () => {
    this.setState({
      imageUploadFailed: false,
    });
  };

  render() {
    const { nodeProps, showImage } = this.props;
    const {
      show,
      blobURL,
      blobPresent,
      isUploading,
      imageUploadFailed,
      snackBarMessage,
      nodeKey,
    } = this.state;

    const { attributes, children } = nodeProps;

    return (
      <Wrapper showImage={showImage} contentEditable={false}>
        <ImageUploadStatus
          imageUploadFailed={imageUploadFailed}
          snackBarMessage={snackBarMessage}
          handleCloseSnackBar={this.handleCloseSnackBar}
        />

        <EditImage
          show={show}
          blobPresent={blobPresent || 'empty'}
          labelKey={nodeKey}
          onChange={this.onChange}
          clearEventValue={this.clearEventValue}
          handleOpenDropdown={this.handleOpenDropdown}
          handleCloseDropdown={this.handleClickOutside}
          handleRemoveDocumentPicture={this.handleRemoveDocumentPicture}
          dataTestId={`document_picture_${nodeKey}`}
          logo
          iconSelector={this.iconSelector}
        />
        <RenderImage
          blobPresent={blobPresent || 'empty'}
          blobURL={blobURL}
          isUploading={isUploading}
        />
        {/* <Export position="absolute" {...nodeProps} /> */}
        {(!blobPresent || blobPresent === 'empty') && (
          <Camera {...attributes}>{children}</Camera>
        )}
      </Wrapper>
    );
  }
}

Image.propTypes = {
  nodeProps: propTypes.objectOf(propTypes.object).isRequired,
  attributes: propTypes.objectOf(propTypes.string).isRequired,
};

const mapStateToProps = (state) => ({
  documentId: state.editResumeFormReducer.documentId,
  documentPicture: state.editResumeFormReducer.documentPicture,
  imageKey: state.editResumeFormReducer.imageKey,
  blobURLs: state.editResumeFormReducer.blobURLs,
  unUsedUrls: state.editResumeFormReducer.unUsedUrls,
});

const mapDispatchToProps = (dispatch) => ({
  updateProfileImage: (params) =>
    dispatch(Actions.editResumeFormActions.updateProfileImage(params)),
  updateBlobURL: (params) =>
    dispatch(Actions.editResumeFormActions.updateBlobURL(params)),
  updateUnusedUrls: (params) =>
    dispatch(Actions.editResumeFormActions.updateUnusedUrls(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Image);
